import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const GridDensityContext = createContext({ density: 'standard', setDensity: () => {} });

const getStoredDensity = () => {
  if (typeof window === 'undefined') return 'standard';
  const stored = window.localStorage.getItem('gridDensity');
  return ['compact', 'standard', 'comfortable'].includes(stored) ? stored : 'standard';
};

export const GridDensityProvider = ({ children }) => {
  const [density, setDensityState] = useState(() => getStoredDensity());

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem('gridDensity', density);
  }, [density]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handler = (event) => {
      if (event.key !== 'gridDensity') return;
      const next = ['compact', 'standard', 'comfortable'].includes(event.newValue)
        ? event.newValue
        : 'standard';
      setDensityState(next);
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const setDensity = (next) => {
    const normalized = ['compact', 'standard', 'comfortable'].includes(next) ? next : 'standard';
    setDensityState(normalized);
  };

  const value = useMemo(() => ({ density, setDensity }), [density]);

  return (
    <GridDensityContext.Provider value={value}>
      {children}
    </GridDensityContext.Provider>
  );
};

export const useGridDensity = () => useContext(GridDensityContext);

